import { HttpMethod, ParamsContainer, defineHandler } from "@tsp/api";

import {
  GetAsanaLinkRequest,
  GetAsanaResponse,
  GetAttachmentLinkRequest,
  GetAttachmentLinkResponse,
} from "./interface";

export const getCommunicationLink = defineHandler<GetAsanaLinkRequest, GetAsanaResponse>({
  path: "/getCommunicationLink",
  method: HttpMethod.POST,
  params: ParamsContainer.Body,
});

export const getAttachmentLink = defineHandler<GetAttachmentLinkRequest, GetAttachmentLinkResponse>({
  path: "/getAttachmentLink",
  method: HttpMethod.POST,
  params: ParamsContainer.Body,
});

export const externalApi = {
  getAttachmentLink,
  getCommunicationLink,
};
